import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';

@Injectable()
export class PersonService{

	constructor(private httpclientService: HttpClientService){}

    // 获取用户信息
	getUserInfo(){
		return this.httpclientService.getMethod({
			url: '/web/user/queryUserInfoById',
		})
    }
    
    // 我的资料 - 信息更新
    userInfoRenew(data: {
        email: string,
        userRole: number,
        firstName: string,
        lastName: string,
        school: string,
        job: string,
        codeType: string,
        code: string | number
    }){
        return this.httpclientService.postMethod({
            url: '/web/user/apply/renew',
            data,
        });
    }

	// 获取我的问题
	getMyQuestion(status: number, pageIndex: number, pageSize = 10){ // status: 1 待回答 4 已回答
		return this.httpclientService.getMethod({
			url: `/web/question/question/list/my?status=${status}&page=${pageIndex}&rows=${pageSize}`,
		})
	}

	// 获取我的回答
	getMyAnswer(status: number | string, pageIndex: number, pageSize = 10){ // status: 1 待回答 4 已回答
		return this.httpclientService.getMethod({
			url: `/web/question/question/list/ask?status=${status}&page=${pageIndex}&rows=${pageSize}`,
		})
	}

	// 回答问题
	answerQuestion(questionId: number | string, answer: string){
		return this.httpclientService.postMethod({
			url: '/web/question/question/ask',
			data: {
				questionId,
				answer,
			},
		})
    }

    // 获取我的视频留言
    getMyVideoComments(pageIndex: number, pageSize = 10){
        return this.httpclientService.getMethod({
            url: `/web/video/speech/comments/my/comments?page=${pageIndex}&rows=${pageSize}`,
        });
    }
    
    // 获取消息列表（消息中心）
    getMessageList(pageIndex: number, pageSize = 10){
        return this.httpclientService.getMethod({
            url: `/web/user/message/list?page=${pageIndex}&rows=${pageSize}` // messageType={消息类型：1 视频宣讲，2 系统}&keyword={搜索关键词}
        });
    }
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/service/person.service.ts